export default __webpack_public_path__ + "static/media/icon_error404.e11e6c69.svg";